import { useCallback } from "react";
import { getOptionByIdWithCORP } from "../../../api/TabwareOptions";
import { useWorkOrderStore } from "../../../store/wo-order";
import { getEquipment } from "../../../api/EquipmentMasters";

export default function useGetTestEquipmentListAndRule() {
  const setTestEquipRule = useWorkOrderStore((state) => state.setTestEquipRule);
  const setTestEquipmentList = useWorkOrderStore(
    (state) => state.setTestEquipmentList
  );
  const getTestEquipmentListAndRule = useCallback(async () => {
    let equipRule = "";
    let equipList = [];
    const resp = await getOptionByIdWithCORP("ICTypeRequiresTestEQ");
    if (resp.status === 200 && resp.data) {
      equipRule = resp.data.PlantValue
        ? resp.data.PlantValue
        : resp.data.DefaultValue;
      setTestEquipRule(equipRule);
    }

    const response = await getEquipment({ filter: "test_equipment_flag eq 1" });
    if (response.status === 200 && response.data) {
      equipList = response.data.filter(
        (r: any) =>
          !r.CalibrationExpiresDate ||
          Date.parse(r.CalibrationExpiresDate) >= Date.now()
      );
      setTestEquipmentList(equipList);
    }
    return { equipRule, equipList };
  }, [setTestEquipRule, setTestEquipmentList]);

  return { getTestEquipmentListAndRule };
}
